function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4983 3.50041C17.0913 3.49141 16.7683 3.15941 16.7693 2.75241C16.7703 2.33241 17.1173 1.99241 17.5373 2.00041L21.0013 2.05541C21.5543 2.05341 22.0013 2.50141 21.9993 3.05441L21.9903 6.45841C21.9883 6.88741 21.6273 7.23141 21.1983 7.21041C20.7983 7.19141 20.4853 6.86241 20.4873 6.46241L20.4923 4.55341L12.1273 12.9184C11.8343 13.2104 11.3593 13.2104 11.0673 12.9184C10.7743 12.6254 10.7743 12.1504 11.0673 11.8574L19.3863 3.53741L17.4983 3.50041ZM17.5 19.5V10.5L19 9.00001V20C19 20.552 18.552 21 18 21H4C3.448 21 3 20.552 3 20V6.00001C3 5.44801 3.448 5.00001 4 5.00001H15L13.5 6.50001H4.5V19.5H17.5Z",
  fill: "currentColor"
});

function SvgIconViewInNewTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewInNewTab);
export default __webpack_public_path__ + "static/media/iconViewInNewTab.c2f39bf0.svg";
export { ForwardRef as ReactComponent };